/**
 * NOTE:
 * should we get TS error codes and match on that?
 * it would probably be more accurate messaging to the consumer
 * for example, a cart can expire on the checkout page
 * and the credit card error message would be misleading
 *
 * Collected messages:
 *
 * 400: CART-00002 - The Cart is no longer active.
 */

export enum ErrorType {
  ErrorTypeNotFound,

  Connection,

  LoadingTickets,
  LoadingAddOns,
  LoadingCalendar,
  LoadingTimeslots,

  NoAvailableDates,

  AddTicketsToCart,
  AddAddOnsToCart,

  ProcessingCard,

  ContactForm,

  CartInactive,

  RedeemPerk,

  Login,

  SessionExpired,

  CapacityExceeded,

  NotFound,
  CartNotFound,
  EventNotFound,
  SessionNotFound,
  ModifyCart,
  Generic,
}

/**
 * Outcomes we deliberately surface to the user in the UI - an expired cart, a declined card,
 * a sold-out session. They are not defects, so ErrorModal does not report them to Sentry at
 * all rather than reporting them and filtering them back out in `beforeSend`.
 */
export const EXPECTED_ERROR_TYPES: ReadonlySet<ErrorType> = new Set([
  ErrorType.ProcessingCard,
  ErrorType.CartInactive,
  ErrorType.SessionExpired,
  ErrorType.CapacityExceeded,
  ErrorType.NoAvailableDates,
])

export type TSError = {
  msgs: string[]
  type: ErrorType
}

/**
 * Shape of errors thrown by api-request.service: a standard Error augmented
 * with the parsed response status and body on `response`.
 */
export type RequestError<T = unknown> = Error & {
  response?: { status: number, data: T }
}

export type ActionResult<T> =
  | { data: T; error: null }
  | { data: null; error: ErrorType; message?: string }

/**
 * Message interface
 * @param {string} title - title of the message
 * @param {React.ReactNode | string} jsxTitle - ReactNode title of the message
 * @param {React.ReactNode | string} body - body of the message
 */
export type Message = {
  title: string
  jsxTitle?: React.ReactNode | string
  body?: React.ReactNode | string
}
